/**
 * @generated SignedSource<<0e8158f5dbf03f9c41a05d6c31e8655d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PregnancyStatus = "NOT_PREGNANT" | "PREGNANT" | "UNKNOWN";
import { FragmentRefs } from "relay-runtime";
export type GynaecologyFragment$data = {
  readonly firstPeriod: number | null;
  readonly id: string;
  readonly menopauseSince: number | null;
  readonly patientId: string;
  readonly pregnancy: PregnancyStatus;
  readonly pregnancyHistory: string | null;
  readonly weeksOfPregnancy: number | null;
  readonly " $fragmentType": "GynaecologyFragment";
};
export type GynaecologyFragment$key = {
  readonly " $data"?: GynaecologyFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"GynaecologyFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GynaecologyFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstPeriod",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "menopauseSince",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pregnancy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pregnancyHistory",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "weeksOfPregnancy",
      "storageKey": null
    }
  ],
  "type": "Gynaecology",
  "abstractKey": null
};

(node as any).hash = "5e8bb11246ea2096d02e31481e9991db";

export default node;
